import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Button } from "@/components/Buttons";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import Loading from "@/components/Loading";
import PreventLink from "@/components/PreventLink";
import { useModal, useNotification, useProductOrdersQuery, useSubscribeMutation, useSubscriptionsQuery } from "@/hooks";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import dayjs from "@/lib/day";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import styles from "@/styles/Account.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import { NetworkStatus } from "@apollo/client";
import Link from "next/link";
import { useCallback } from "react";
var IconCaution = function IconCaution(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
      transform: "translate(0 0)",
      fill: "#eb7d3c"
    })
  }));
};
IconCaution.defaultProps = {
  viewBox: "0 0 14 12"
};
import ApplyingCampaignStatusModal from "../ApplyingCampaignStatusModal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ModalContent(_ref) {
  let {
    hideModal
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h4", {
      children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u6709\u52B9\u6027\u304C\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093"
    }), /*#__PURE__*/_jsxs("div", {
      className: modalStyles.confirmPaymentMethod,
      children: ["\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u6709\u52B9\u6027\u304C\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u306E\u3067\u3001\u4E00\u6642\u7684\u306B\u3054\u8996\u8074\u3067\u304D\u306A\u3044\u72B6\u614B\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u3054\u6C7A\u6E08\u65E5\u304B\u30893\u65E5\u4EE5\u5185\u306B\u304A\u652F\u6255\u3044\u60C5\u5831\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u306A\u304A\u3001\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u6709\u52B9\u6027\u304C\u78BA\u8A8D\u3067\u304D\u306A\u304B\u3063\u305F\u5834\u5408\u306F\u3054\u89E3\u7D04\u3068\u306A\u308A\u307E\u3059\u3002"]
    }), /*#__PURE__*/_jsx("div", {
      className: `${modalStyles.btnArea} ${modalStyles.multiple}`,
      children: /*#__PURE__*/_jsx(Button, {
        borderGray: true,
        fontFixed: true,
        large: true,
        onClick: hideModal,
        children: "\u9589\u3058\u308B"
      })
    })]
  });
}
function ApplyingStatus(_ref2) {
  let {
    subscription
  } = _ref2;
  const {
    showModal
  } = useModal();
  const handleClick = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(ApplyingCampaignStatusModal, {
      subscription: subscription
    }), {
      style: "dialogue"
    });
  }, []);
  return /*#__PURE__*/_jsx("a", {
    onClick: handleClick,
    children: "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u7B49\u306E\u9069\u7528\u72B6\u6CC1\u306F\u3053\u3061\u3089"
  });
}
function SubscriptionRow(_ref3) {
  var _course$active_pricin;
  let {
    data,
    suspendModal,
    resubscribe
  } = _ref3;
  const {
    course,
    status,
    course_id,
    payment_method_id,
    payment_instrument,
    payment_instrument_id,
    subscription_id,
    nextTransactionAt,
    suspend_flag,
    withdraw_at
  } = data;
  const {
    card_type,
    card_number
  } = (payment_instrument === null || payment_instrument === void 0 ? void 0 : payment_instrument.values) || {};
  const cardNumber = `****-****-****-${card_number}`;
  const withdrawAt = dayjs(withdraw_at).format("MM/DD");
  const hasCampaign = !!(course !== null && course !== void 0 && (_course$active_pricin = course.active_pricing) !== null && _course$active_pricin !== void 0 && _course$active_pricin.campaign);
  const handleResubscribe = useCallback(async () => {
    await resubscribe(course_id, payment_instrument_id);
  }, [course_id, payment_method_id]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.row,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.name,
      children: course.name
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.price,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u4FA1\u683C"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.cell,
        children: [status === "trial" && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("span", {
            children: [course.trialText, "\u671F\u9593\u4E2D"]
          }), /*#__PURE__*/_jsx(ApplyingStatus, {
            subscription: data
          })]
        }), status !== "trial" && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("span", {
            children: [hasCampaign && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("span", {
                children: "\u5272\u5F15\u9069\u7528\u4FA1\u683C"
              }), " "]
            }), "\u6708\u984D", formatPrice(course.price), "\u5186"]
          }), hasCampaign && /*#__PURE__*/_jsx(ApplyingStatus, {
            subscription: data
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.paymentMethod,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u652F\u6255\u3044\u65B9\u6CD5"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.cell,
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.paymentMethodIcon,
            children: /*#__PURE__*/_jsx(PaymentIconImage, {
              paymentMethodId: payment_method_id,
              cardType: card_type,
              onDark: true
            })
          }), (payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS || payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS) && /*#__PURE__*/_jsx("span", {
            className: styles.cardNumber,
            children: cardNumber
          })]
        }), /*#__PURE__*/_jsx(Link, {
          href: routes.accountChangeSvodPayment(subscription_id),
          children: "\u5909\u66F4\u3059\u308B"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.nextPayment,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u6B21\u56DE\u6C7A\u6E08\u65E5"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.cell,
        children: [suspend_flag && /*#__PURE__*/_jsxs("a", {
          onClick: suspendModal,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.iconCaution,
            children: /*#__PURE__*/_jsx(IconCaution, {})
          }), "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u6709\u52B9\u6027\u304C\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093"]
        }), !suspend_flag && /*#__PURE__*/_jsx("span", {
          children: nextTransactionAt
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.link,
      children: [(status === "waiting_apply_cancel" || status === "applied_cancel") && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs("span", {
            children: [withdrawAt, "\u89E3\u7D04\u4E88\u5B9A"]
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(PreventLink, {
            onClick: handleResubscribe,
            children: "\u89E3\u7D04\u3092\u53D6\u308A\u6D88\u3059"
          })
        })]
      }), (status === "contracted" || status === "trial") && /*#__PURE__*/_jsx(Link, {
        href: routes.unsubscribe(course_id),
        children: "\u89E3\u7D04\u3059\u308B"
      })]
    })]
  });
}
function ProductOrderRow(_ref4) {
  var _data$order, _data$entitlements;
  let {
    data
  } = _ref4;
  const price = data === null || data === void 0 || (_data$order = data.order) === null || _data$order === void 0 ? void 0 : _data$order.payment_amount;
  const orderDate = dayjs(data.created_at).format("YYYY/MM/DD HH:mm");
  const viewPeriod = data === null || data === void 0 || (_data$entitlements = data.entitlements) === null || _data$entitlements === void 0 || (_data$entitlements = _data$entitlements[0]) === null || _data$entitlements === void 0 ? void 0 : _data$entitlements.end_at;
  const viewPeriodFormatted = viewPeriod && dayjs(viewPeriod).format("YYYY/MM/DD HH:mm");
  return /*#__PURE__*/_jsxs("div", {
    className: styles.row,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.name,
      children: data.name
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.price,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u4FA1\u683C"
      }), !isNaN(price) && `${formatPrice(price)}円`]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.orderDate,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u8CFC\u5165\u65E5"
      }), orderDate]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.viewPeriod,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u8996\u8074\u53EF\u80FD\u671F\u9593"
      }), viewPeriodFormatted]
    })]
  });
}
export default function Product() {
  var _productOrderData$pro;
  const {
    showNotification
  } = useNotification();
  const {
    showModal,
    hideModal
  } = useModal();
  const handleShowModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(ModalContent, {
      hideModal: hideModal
    }), {
      closeButton: false,
      outerAreaClose: false,
      style: "dialogue"
    });
  }, []);
  const {
    data: subscriptionData,
    loading: subscriptionLoading,
    refetch,
    networkStatus
  } = useSubscriptionsQuery({
    notifyOnNetworkStatusChange: true
  });
  const refetching = networkStatus === NetworkStatus.refetch;
  const subscriptions = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptions;
  const {
    data: productOrderData,
    loading: productLoading
  } = useProductOrdersQuery({
    variables: {
      with_order: true,
      with_payment_instrument: false,
      with_entitlements: true,
      type: "is-entitled"
    }
  });
  const productOrders = productOrderData === null || productOrderData === void 0 || (_productOrderData$pro = productOrderData.productOrders) === null || _productOrderData$pro === void 0 ? void 0 : _productOrderData$pro.data;
  const [subscribe] = useSubscribeMutation({
    onCompleted: _ref5 => {
      let {
        subscribe
      } = _ref5;
      if ((subscribe === null || subscribe === void 0 ? void 0 : subscribe.status) == "contracted") {
        showNotification("解約を取り消しました", {
          time: 2000
        });
        refetch();
      } else if (subscribe !== null && subscribe !== void 0 && subscribe.error) {
        showNotification(subscribe.error, {
          time: 2000,
          caution: true
        });
      }
    }
  });
  const handleResubscribe = useCallback(async (courseId, paymentInstrumentId) => {
    await subscribe({
      variables: {
        courseId: courseId,
        paymentInstrumentId: paymentInstrumentId
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(refetching || subscriptionLoading || productLoading) && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), /*#__PURE__*/_jsx("div", {
      className: styles.accountInfo,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.contentsInner,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${styles.contentBox} ${styles.personalInfo}`,
          children: [subscriptions && (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) !== 0 && !subscriptionLoading && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.contentHeader,
              children: /*#__PURE__*/_jsx("h3", {
                className: styles.contentTitle,
                children: "\u6708\u984D\u5546\u54C1"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: styles.info,
              children: "\u203B\u6B21\u56DE\u3054\u6C7A\u6E08\u65E5\u306B\u5272\u5F15\u6761\u4EF6\u3092\u6E80\u305F\u3057\u3066\u3044\u308B\u5834\u5408\u306B\u5272\u5F15\u4FA1\u683C\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u8ACB\u6C42\u306B\u3064\u3044\u3066\u306E\u5272\u5F15\u9069\u7528\u78BA\u8A8D\u306B\u3064\u3044\u3066\u306F\u304A\u652F\u6255\u3044\u5C65\u6B74\u306B\u3066\u6C7A\u6E08\u91D1\u984D\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.header,
                children: /*#__PURE__*/_jsxs("div", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.name,
                    children: "\u5546\u54C1"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.price,
                    children: "\u4FA1\u683C"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.paymentMethod,
                    children: "\u652F\u6255\u3044\u65B9\u6CD5"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.nextPayment,
                    children: "\u6B21\u56DE\u3054\u6C7A\u6E08\u65E5"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.link
                  })]
                })
              }), /*#__PURE__*/_jsx("div", {
                className: styles.body,
                children: subscriptions.map((data, i) => /*#__PURE__*/_jsx(SubscriptionRow, {
                  data: data,
                  suspendModal: handleShowModal,
                  resubscribe: handleResubscribe
                }, `subscriptionrow-${i}`))
              })]
            })]
          }), productOrders && (productOrders === null || productOrders === void 0 ? void 0 : productOrders.length) !== 0 && !productLoading && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.contentHeader,
              children: /*#__PURE__*/_jsx("h3", {
                className: styles.contentTitle,
                children: "\u5358\u54C1\u5546\u54C1"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: styles.info,
              children: "\u203B\u3053\u3061\u3089\u306E\u4FA1\u683C\u306B\u3064\u3044\u3066\u306F\u6C7A\u6E08\u3055\u308C\u305F\u4FA1\u683C\u3092\u8868\u793A\u3057\u3066\u304A\u308A\u307E\u3059\u305F\u3081\u3001\u5272\u5F15\u304C\u9069\u7528\u3055\u308C\u305F\u5834\u5408\u306F\u9069\u7528\u6E08\u307F\u306E\u4FA1\u683C\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.header,
                children: /*#__PURE__*/_jsxs("div", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.name,
                    children: "\u5546\u54C1"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.price,
                    children: "\u4FA1\u683C"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.orderDate,
                    children: "\u8CFC\u5165\u65E5"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.viewPeriod,
                    children: "\u8996\u8074\u53EF\u80FD\u671F\u9593"
                  })]
                })
              }), /*#__PURE__*/_jsx("div", {
                className: styles.body,
                children: productOrders.map((data, i) => /*#__PURE__*/_jsx(ProductOrderRow, {
                  data: data
                }, `productorderrow-${i}`))
              })]
            })]
          }), ((productOrders === null || productOrders === void 0 ? void 0 : productOrders.length) !== 0 && !productLoading || (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) !== 0 && !subscriptionLoading) && /*#__PURE__*/_jsx("div", {
            className: styles.info,
            children: /*#__PURE__*/_jsx("p", {
              children: "\u203B\u3059\u3079\u3066\u7A0E\u8FBC\u307F\u8868\u8A18"
            })
          }), (productOrders === null || productOrders === void 0 ? void 0 : productOrders.length) === 0 && !productLoading && (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) === 0 && !subscriptionLoading && /*#__PURE__*/_jsx("div", {
            className: styles.noContent,
            children: "\u3054\u5229\u7528\u4E2D\u306E\u6708\u984D\u5546\u54C1\u3001\u5358\u54C1\u5546\u54C1\u306F\u3042\u308A\u307E\u305B\u3093"
          })]
        })
      })
    })]
  });
}